import { useCallback, useRef } from "react";

export type SaveCardCheckoutNote = (input: {
  checkoutSessionId: string;
  note: string;
}) => Promise<void>;

/**
 * Process Payment Internal Notes for a card payment: the card form starts
 * before staff type a note, so the note is saved on the open card Session
 * just before the card is submitted. Only a changed note for that Session is
 * saved. A failed save throws, and the card form does not submit.
 */
export const useCardCheckoutNoteBeforeConfirm = ({
  note,
  saveNote,
}: {
  note: string;
  saveNote: SaveCardCheckoutNote;
}) => {
  const noteRef = useRef(note);
  noteRef.current = note;
  // "{Session ID}\n{note}" last saved ("" = none).
  const savedNoteKeyRef = useRef("");

  return useCallback(
    async (checkoutSessionId: string) => {
      const cardNote = noteRef.current.trim();
      const noteKey = `${checkoutSessionId}\n${cardNote}`;
      const savedForSession = savedNoteKeyRef.current.startsWith(
        `${checkoutSessionId}\n`,
      );
      if (
        noteKey === savedNoteKeyRef.current ||
        (!cardNote && !savedForSession)
      ) {
        return;
      }
      await saveNote({ checkoutSessionId, note: cardNote });
      savedNoteKeyRef.current = noteKey;
    },
    [saveNote],
  );
};
